export const checkoutUrl = ({ packageIds, trialInfo, origin }) => {
  const packageIdString = packageIds.join(',');
  const url = `/summit/checkout?package_ids=${packageIdString}&origin=${origin}`;

  if (trialInfo && trialInfo.code) {
    return `${url}&trial_code=${trialInfo.code}`;
  }

  return url;
};

export default { checkoutUrl };
